export default {

  /** 分页查询油罐费用列表 */
  selectYgCostByPage: '/ygsjzs/ygCost/selectYgCostByPage',
  /** 查询开票记录详情 */
  selectYgInvoiceByInvoiceId: '/ygsjzs/ygInvoice/selectYgInvoiceByInvoiceId',
  /** 分页查询开票记录列表 */
  selectYgInvoiceByList: '/ygsjzs/ygInvoice/selectYgInvoiceByList',
  /** 申请开票记录 */
  insertYgInvoice: '/ygsjzs/ygInvoice/insertYgInvoice',
  /** 审批开票记录 */
  updateYgInvoice: '/ygsjzs/ygInvoice/updateYgInvoice',
  // 绩效统计
  selectYgCostJx: '/ygsjzs/ygCost/selectYgCostJx'
}
